import { createSelector } from '@reduxjs/toolkit';

import type { Shipment } from '../../models/shipments';
import { RootState } from '../store';

/**
 * A combined array of fetched shipment(s) and recently searched shipment
 * @returns existing shipments and additional searched shipment (that is not a duplicate)
 */
export const selectShipments = createSelector(
  [
    (state: RootState) => state.shipmentList.data,
    (state: RootState) => state.shipmentList.removedArticleIds,
    (state: RootState) => state.shipmentList.recentlySearched,
  ],
  (shipmentList, removedIds, recentlySearched): Shipment[] | [] => {
    const data = shipmentList || [];
    const removed = removedIds ?? [];
    const searched = recentlySearched || [];

    if (!data?.length && !searched?.length) return [];

    const searchedIds = new Set(data.map((searchedShipment) => searchedShipment.consignmentId));

    const combinedSearchResults = [
      ...data,
      ...searched.filter((newSearched) => !searchedIds.has(newSearched.consignmentId)),
    ];

    if (removed.length) {
      const removedIdSet = new Set(removed);
      const updatedResult = combinedSearchResults.filter((combined) => !removedIdSet.has(combined.consignmentId));
      return updatedResult;
    }
    return combinedSearchResults;
  }
);
export const selectShipment = (state: RootState) => {
  return state.shipmentDetails.data;
};

export const isListShipmentLoading = (state: RootState): boolean => {
  return state.shipmentList?.getShipmentList?.loading || false;
};
